<template>
    <div>
        <MessageSection>
            <div class="bodyCopy">Please rate your experience with {{message.ownerName}}. </div>
        </MessageSection>
        <MessageSection class="tc">
            <AdjustableRating :inline="true" v-model="rating"/>
            <!-- <img v-for="index in 5" :key="index" @mouseover="onHover(index)" @click="onClick(index)" class="h2 grow pointer" :src="getImage(index)"/> -->
        </MessageSection>
    </div>
</template>

<script>
import MessageSection from '@/components/inbox/messagesCard/shared/MessageSection.vue';
import AdjustableRating from '@/components/global/AdjustableRating.vue';
export default {
    data() {
        return {
            hover: null,
            rating: null
        };
    },
    components: {
        MessageSection,
        AdjustableRating
    },
    props: {
        message: {}
    }
    // methods: {
    //     onHover(index) {
    //         if (!this.rating) {
    //             this.hover = index;
    //         }
    //     },
    //     onClick(index) {
    //         this.hover = null;
    //         this.rating = index;
    //     },
    //     getImage(index) {
    //         if (index <= this.rating || index <= this.hover) {
    //             return require('@/assets/img/icon_rating_yellow.svg');
    //         } else {
    //             return require('@/assets/img/icon_star.svg');
    //         }
    //     }
    // }
};
</script>
